import React from 'react';

import ReviewsView from 'four-nets/bazaar/review/reviews-view';

import BazaarProfilePureView from './bazaar-profile-pure-view';

import { BazaarProfile, BazaarProfileStore } from 'four-nets/bazaar/bazaar';
import { User, UserStore } from 'four-nets/user/user';

import defaultStyles, { BazaarProfileViewStyles } from './bazaar-profile-view.scss';

export interface Props {
    styles: typeof defaultStyles;
    user: User;
    bazaarProfile?: BazaarProfile;
    bazaarProfileStore: BazaarProfileStore;
    hideEdit?: boolean;
    shopInfoTitle: React.ReactNode;
    noShopInfo: React.ReactNode;
    userStore: UserStore;
    linkToProfile?: boolean;
    profileStyle?: Partial<BazaarProfileViewStyles>;
}
export interface State {
    fromSellers: boolean;
    open: boolean;
}

class BazaarProfileView extends React.Component<Props, State> {
    state = { open: false, fromSellers: false };

    close = () => {
        this.setState({ open: false });
    };

    showReviews = () => {
        this.setState({ open: true });
    };

    changeType = (fromSellers: boolean) => {
        this.setState({ fromSellers });
    };

    render() {
        const {
            user,
            bazaarProfile,
            bazaarProfileStore,
            hideEdit,
            shopInfoTitle,
            noShopInfo,
            userStore,
            linkToProfile,
            profileStyle,
        } = this.props;

        return (
            <BazaarProfilePureView
                style={profileStyle}
                showReviews={this.showReviews}
                changeType={this.changeType}
                user={user}
                bazaarProfile={bazaarProfile}
                bazaarProfileStore={bazaarProfileStore}
                hideEdit={hideEdit}
                shopInfoTitle={shopInfoTitle}
                noShopInfo={noShopInfo}
                userStore={userStore}
                linkToProfile={linkToProfile}
            >
                <ReviewsView
                    open={this.state.open}
                    onClose={this.close}
                    fromSellers={this.state.fromSellers}
                    showReviews={this.showReviews}
                    changeType={this.changeType}
                    user={user}
                    bazaarProfile={bazaarProfile}
                    bazaarProfileStore={bazaarProfileStore}
                    hideEdit={hideEdit}
                    shopInfoTitle={shopInfoTitle}
                    noShopInfo={noShopInfo}
                    userStore={userStore}
                />
            </BazaarProfilePureView>
        );
    }
}

export default BazaarProfileView;
